window.addEventListener('OpusCartChange', (event) => {
  const targetItems = document.querySelectorAll('.cd-rewards-container');
  console.log("targetItems", targetItems); 
  if (Shopify && Shopify.country === 'IN') {
    targetItems.forEach(item => {
      item.style.setProperty('display', 'none', 'important');
      console.log(item.style.display); 
    });
  } else {
    targetItems.forEach(item => {
      item.style.display = '';
    });
  }
}); 